import { useIonModal } from "@ionic/react";
import { RequestModel } from "model";

import AllDatesTimesModal from "./AllDatesTimesModal";

export const useAllDatesTimes = (request: RequestModel) => {
  const isScrollbarNeeded = request?.getIntervals().length <= 12;
  const [presentModal, dismissModal] = useIonModal(AllDatesTimesModal, {
    model: request,
    isScrollbarNeeded,
    onDismiss: () => dismissModal(),
  });
  const openAllDatesTimesModal = () => {
    presentModal({
      cssClass: isScrollbarNeeded ? "swing-no-scroll-modal" : "",
    });
  };

  return { openAllDatesTimesModal };
};
